import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscriptions } from '@k2/common/helpers';
import { IsAllowedService } from '@k2/common/permissions/IsAllowedService';

@Directive({
    selector: '[ifAllowed]',
    standalone: false
})
export class IfAllowedDirective implements OnInit, OnDestroy {
  @Input('ifAllowed') expression: string;

  private readonly subscriptions = new Subscriptions();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private isAllowedService: IsAllowedService
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.isAllowedService
        .isAllowed(this.expression)
        .subscribe(isAllowed => {
          if (isAllowed) {
            this.viewContainer.createEmbeddedView(this.templateRef);
          } else {
            this.viewContainer.clear();
          }
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
